export default __webpack_public_path__ + "static/media/dental_home.98797e88.svg";